module.exports = __webpack_public_path__ + "assets/img/tech-16.29fb877a.svg";